import { object, string, number, boolean, array, mixed, ObjectSchema, InferType } from "yup";
import { BankAccountType } from "../../../shared/utils/enum/enum";
import { BancoContract, AgenciaContract, ContaContract } from "../contracts/cadastro-bancario.contracts";

export const contaSchema: ObjectSchema<ContaContract> = object({
    id: string().optional(),
    accountNumber: string().required("Informe o número da conta"),
    digit: string().required("Informe o dígito da conta"),
    name: string().optional(),
    initialBalance: number()
        .typeError("Valor total deve ser um número")
        .transform((value, originalValue) => {
            if (typeof originalValue === "string") {
                const cleaned = originalValue
                    .replace(/[^\d.,]/g, "")
                    .replace(/\./g, "")
                    .replace(",", ".");
                if (!cleaned) return undefined;
                const valorNumber = Number(cleaned);
                return isNaN(valorNumber) ? undefined : valorNumber;
            }
            return value;
        })
        .optional(),
    active: boolean().required("Informe se a conta está ativa"),
    type: mixed<BankAccountType>().required("Informe o tipo da conta"),
});

export const agenciaSchema: ObjectSchema<AgenciaContract> = object({
    id: string().optional(),
    agencyNumber: string().required("Informe o número da agência"),
    digit: string().optional(),
    name: string().optional(),
    active: boolean().required("Informe se a agência está ativa"),
    accounts: array(contaSchema)
        .min(1, "Informe ao menos uma conta")
        .required("Informe as contas da agência"),
});

export const bancoSchema: ObjectSchema<BancoContract> = object({
    id: string().optional(),
    name: string().required("Informe o nome do banco"),
    code: string().required("Informe o código do banco"),
    active: boolean().required("Informe se o banco está ativo"),
    agencies: array(agenciaSchema)
        .min(1, "Informe ao menos uma agência")
        .required("Informe as agências do banco"),
});

export type BancoFormData = InferType<typeof bancoSchema>;